export default __webpack_public_path__ + "static/media/zukunf_lauft_s3.06cbc9e5.png";